module.exports = __webpack_public_path__ + "static/media/monkeyisland3.89bc1167.gif";